import ReminderService from "../../../services/reminder/ReminderService";
import serviceDocument from "../../../services/patient/DocumentService";
import i18n from "../../../i18n/index";

export default {
  props: ["reminderDate", "onRowClick"],
  data() {
    return {
      search: "",
      date: new Date().toISOString().substr(0, 10),
      headers: [
        {
          text: i18n.t('headers.date'),
          sortable: false,
          value: "date"
        },
        {
          text: i18n.t('headers.document-type'),
          sortable: false,
          value: "documentType"
        },
        {
          text: i18n.t('headers.patient-document'),
           value: "patientName", sortable: false
        },
        {
          id: 3,
          text: i18n.t('headers.patient-name'),
          sortable: false,
          value: "patient_name"
        },
        {
          text: i18n.t('headers.nro-order'),
          value: "",
          sortable: false
        },
        {
          text: i18n.t('headers.policy'),
          value: "",
          sortable: false
        },
        {
          text: i18n.t('headers.pac'),
          value: "",
          sortable: false
        }
      ],
      loading: false,
      pagination: {},
      rowsPerPageItems: [5, 10, 15, 20],
      reminderItems: [],
      totalItems: 0,
      menu2: false
    };
  },
  watch: {
    pagination: {
      handler() {
        this.getReminders();
      },
      deep: true
    }
  },
  methods: {
    getReminders() {
      this.loading = true;
      const { page, rowsPerPage } = this.pagination;
      ReminderService.getReminders(this.date, page - 1, rowsPerPage, this.search).then(
        data => {
          this.loading = false;
          this.reminderItems = data.data[0];
          this.totalItems = data.data[1];
        }
      );
    },

    reloadGrid() {
      this.menu2 = false;
      this.getReminders();
    }
  },
  filters: {
    capitalize: function (value) {
      value = value.toString();
      return value.toUpperCase();
    }
  }
};
